// extracted by css-extract-rspack-plugin
export default {"root":"FixedBackground_root__kdgsq","blend":"FixedBackground_blend__zHhuV"};